import { Title } from 'react-head'
import MediaLibrary from '../components/MediaLibrary'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useMemo } from 'react'

const MediaRoute = () => {
  const { tr } = useTr()

  const title = useMemo(() => {
    return tr(TrKey.mediaRouteTitle) + ' | Atlascloud'
  }, [tr])

  return (
    <div className='content pb-20'>
      <Title>{title}</Title>
      <h1 className='m0 primblue l'>{tr(TrKey.mediaRouteTitle)}</h1>
      <MediaLibrary inModal={false} enableUsageQuota />
    </div>
  )
}

export default MediaRoute
